import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';



import {
  CircularProgress,
} from 'material-ui';

import {
  NumberIndex,
  ProjectSummaryList,
  ProjectDistributionGraph,
  ProjectDistributionPie,
} from 'imports/ComponentsImports';


const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginLeft: '1em',
  },
  subHeader: {
    margin: '0 0 1em 2em',
  },
  dataContainer: {
    display: 'flex',
    marginBottom: '1em',
  },
  data: {
    flex: 1,
    margin: '0 1em',
  },
  disagreggatedDataContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  graphsContainer: {
    flex: 1,
    display: 'flex',
  },
  graph: {
    flex: 1,
    margin: '1em'
  }
}

class DashboardProjectsView extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: this.props.cookies.get('user'),
      token: this.props.cookies.get('token'),
      error: false,
      loading: true,
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar la etapa en la que se encuentra su empresa. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.container}>
        <h1 style={styles.header}> 3. Dashboard </h1>
        <h2 style={styles.subHeader}> 3.2 Datos por proyecto</h2>
        <div style={styles.dataContainer}>
          <NumberIndex
            value={this.state.projectsByState.postulated_projects.length}
            valueName="Proyectos postulados"
            header=""
            style={styles.data}
            />
          <NumberIndex
            value={this.state.projectsByState.selected_projects.length}
            valueName="Proyectos seleccionados"
            header=""
            style={styles.data}
            />
          <NumberIndex
            value={this.state.projectsByState.measured_projects.length}
            valueName="Proyectos medidos"
            header=""
            style={styles.data}
            />
        </div>
        <div style={styles.disagreggatedDataContainer}>
          <div style={styles.graphsContainer}>
            <ProjectDistributionGraph
              style={styles.graph}
              title="Distribución del aporte económico por proyecto"
              data={this.state.dataByProject}
              currency={this.state.companyData.currency}
              indicator={this.state.companyData.indicator}/>
            <ProjectDistributionPie
              style={styles.graph}
              title="Distribución del aporte económico por proyecto"
              data={this.state.dataByProject}
              currency={this.state.companyData.currency}
              indicator={this.state.companyData.indicator}/>
          </div>
          <ProjectSummaryList style={styles.graph} projects={this.state.dataByProject}/>
        </div>
      </div>
    );
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    var projectsByState = connection.get(routes.projectsByState(this.state.user.company_id))
    var dataByProject = connection.get(routes.dataByProject(this.state.user.company_id))
    var companyData = connection.get(routes.company(this.state.user.company_id))
    Promise.all([projectsByState, dataByProject, companyData])
    .then((responses) => {
      this.setState({
        loading: false,
        error: false,
        projectsByState: responses[0].data,
        dataByProject: responses[1].data,
        companyData: responses[2].data,
      })
    })
    .catch((error) => {
      this.setState({
        loading: false,
        error: true,
      });
      console.error(error);
    })
  }
}

export default withRouter(withCookies(DashboardProjectsView));



// WEBPACK FOOTER //
// ./src/views/dashboard/DashboardProjectsView.js